export default {"src":"/_next/static/media/open_source.beb394c2.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};